import axios from "axios";

export const updateRepairStatus = async (id, data) => {
  await axios.put(
    `${process.env.REACT_APP_BASE_URL}/api/v1/repair/repair/${id}`,
    data
  );
  return "Repair status updated successfully";
};
